import { makeEntity } from "./_base";
export const Company = makeEntity("/companies");
